import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

const ADMIN_PHONE = '+917017138355';

export default function Navbar({ userName, userPhone }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();
  const isGuest = !userName || userName === 'Guest User';

  const logout = () => {
    localStorage.removeItem('guningo_user');
    navigate('/');
  };

  const goToLogin = () => {
    setMenuOpen(false);
    navigate('/');
  };

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      <div style={styles.navbar}>
        <div style={styles.navLogo} onClick={() => go('/home')}>🚗 Guningo</div>

        <div style={styles.desktopLinks} className="desktop-only">
          <span style={styles.navLink} onClick={() => go('/home')}>{t('findARide')}</span>
          <span style={styles.navLink} onClick={() => go('/my-bookings')}>{t('myBookings')}</span>
          <span style={styles.navLink} onClick={() => go('/notifications')}>{t('notifications')}</span>
          <span style={styles.postRideBtn} onClick={() => go('/offer')}>{t('postARide')}</span>

          <div style={styles.langToggle}>
            <button style={language === 'en' ? styles.langBtnActive : styles.langBtn} onClick={() => setLanguage('en')}>EN</button>
            <button style={language === 'hi' ? styles.langBtnActive : styles.langBtn} onClick={() => setLanguage('hi')}>हि</button>
          </div>

          <div style={styles.avatarMenu} className="avatar-menu-wrap">
            <div style={styles.avatar}>{userName ? userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : '??'}</div>
            <div style={styles.avatarDropdown} className="avatar-dropdown">
             <span style={styles.dropdownItem} onClick={() => go('/profile')}>👤 {t('profile')}</span>
<span style={styles.dropdownItem} onClick={() => go('/messages')}>💬 Messages</span>
              <span style={styles.dropdownItem} onClick={() => go('/ratings')}>⭐ {t('ratings')}</span>
              <span style={styles.dropdownItem} onClick={() => go('/earnings')}>💰 {t('earnings')}</span>
              <span style={styles.dropdownItem} onClick={() => go('/feedback')}>💬 {t('feedback')}</span>
             {userPhone === ADMIN_PHONE && (
  <span style={styles.dropdownItem} onClick={() => go('/admin')}>🛡️ Admin</span>
)}
{isGuest ? (
  <span style={{ ...styles.dropdownItem, color: '#3a8fd0' }} onClick={goToLogin}>🔐 Login / Sign Up</span>
) : (
  <span style={{ ...styles.dropdownItem, color: '#e94560' }} onClick={logout}>{t('logout')}</span>
)}
            </div>
          </div>
        </div>

        <button style={styles.hamburger} className="hamburger-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {menuOpen && (
        <div style={styles.mobileMenu} className="mobile-menu-open">
          <div style={styles.mobileLangRow}>
            <button style={language === 'en' ? styles.langBtnActive : styles.langBtn} onClick={() => setLanguage('en')}>EN</button>
            <button style={language === 'hi' ? styles.langBtnActive : styles.langBtn} onClick={() => setLanguage('hi')}>हि</button>
          </div>
          <span style={styles.mobileLink} onClick={() => go('/home')}>🏠 {t('findARide')}</span>
          <span style={styles.mobileLink} onClick={() => go('/offer')}>🚗 {t('postARide')}</span>
          <span style={styles.mobileLink} onClick={() => go('/my-bookings')}>🎫 {t('myBookings')}</span>
          <span style={styles.mobileLink} onClick={() => go('/notifications')}>🔔 {t('notifications')}</span>
        <span style={styles.mobileLink} onClick={() => go('/profile')}>👤 {t('profile')}</span>
<span style={styles.mobileLink} onClick={() => go('/messages')}>💬 Messages</span>
          <span style={styles.mobileLink} onClick={() => go('/ratings')}>⭐ {t('ratings')}</span>
          <span style={styles.mobileLink} onClick={() => go('/earnings')}>💰 {t('earnings')}</span>
          <span style={styles.mobileLink} onClick={() => go('/feedback')}>💬 {t('feedback')}</span>
          {userPhone === ADMIN_PHONE && (
            <span style={styles.mobileLink} onClick={() => go('/admin')}>🛡️ Admin</span>
          )}
          {!isGuest && userName && <div style={styles.mobileUserName}>Logged in as {userName}</div>}
{isGuest ? (
  <button style={styles.mobileLoginBtn} onClick={goToLogin}>🔐 Login / Sign Up</button>
) : (
  <button style={styles.mobileLogoutBtn} onClick={logout}>{t('logout')}</button>
)}
        </div>
      )}
    </>
  );
}

const styles = {
  navbar: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 30px', background: '#ffffff', borderBottom: '1px solid #eef1f8',
    position: 'sticky', top: 0, zIndex: 100,
  },
  navLogo: { fontSize: 18, fontWeight: 800, color: '#1a1a2e', cursor: 'pointer' },
  desktopLinks: { display: 'flex', gap: 20, alignItems: 'center' },
  navLink: { fontSize: 13, fontWeight: 600, color: '#5a5f7d', cursor: 'pointer' },
  postRideBtn: {
    border: '1.5px solid #3a8fd0', color: '#3a8fd0', borderRadius: 20,
    padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
  },
  langToggle: { display: 'flex', gap: 4 },
  langBtn: { border: '1px solid #eef1f8', background: '#f7f9fc', borderRadius: 6, padding: '5px 9px', fontSize: 11, fontWeight: 600, cursor: 'pointer', color: '#5a5f7d' },
  langBtnActive: { border: '1px solid #3a8fd0', background: '#3a8fd0', borderRadius: 6, padding: '5px 9px', fontSize: 11, fontWeight: 700, cursor: 'pointer', color: '#fff' },
  avatarMenu: { position: 'relative' },
  avatar: {
    width: 36, height: 36, borderRadius: 18, background: '#eaf5fc', color: '#3a8fd0',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12, cursor: 'pointer',
  },
  avatarDropdown: {
  position: 'absolute', top: 36, right: 0, background: '#fff', borderRadius: 12,
  boxShadow: '0 10px 30px rgba(0,0,0,0.12)', padding: '16px 8px 8px', minWidth: 170,
},
  dropdownItem: { display: 'block', padding: '10px 12px', fontSize: 13, fontWeight: 600, color: '#1a1a2e', cursor: 'pointer', borderRadius: 8 },
  hamburger: {
    display: 'none', background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#1a1a2e',
  },
 mobileMenu: {
  display: 'flex', flexDirection: 'column', background: '#ffffff',
  padding: '10px 20px 20px', borderBottom: '1px solid #eef1f8', gap: 4,
  boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
},
  mobileLangRow: { display: 'flex', gap: 6, padding: '10px 0' },
  mobileLink: { padding: '12px 0', fontSize: 15, fontWeight: 600, color: '#1a1a2e', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' },
  mobileUserName: { padding: '12px 0', fontSize: 12, color: '#9499b5' },
  mobileLogoutBtn: {
    marginTop: 10, background: '#fff5f7', border: '1.5px solid #e94560', color: '#e94560',
    borderRadius: 8, padding: 12, fontWeight: 700, cursor: 'pointer', fontSize: 14,
  },
  mobileLoginBtn: {
  marginTop: 10, background: '#eaf5fc', border: '1.5px solid #3a8fd0', color: '#3a8fd0',
  borderRadius: 8, padding: 12, fontWeight: 700, cursor: 'pointer', fontSize: 14,
},
};